/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backgrid from 'backgrid';

import './DropdownCell.css';
import tmplDropdownButtonCell from './DropdownCell.hbs';

const DropdownCell = Backgrid.Cell.extend({
  className: 'drop-down-button-cell td-grid-cell-btn',

  events: {
    'click .btn-stand-alone': 'onClickStandAloneButton',
    'click .dropdown-item': 'onClickDropdownLink'
  },

  dropdownActions: {},

  render() {
    const actions = this.optionFunction();
    let buttonClass = 'btn-primary btn-xs';
    if (this.buttonClass) {
      buttonClass = Backgrid.callByNeed(this.buttonClass, this, this.model);
    }
    this.$el.addClass(this.column.get('name'));
    if (this.buttonParentClass) {
      this.$el.addClass(this.buttonParentClass);
    }
    const ariaLabel = this.column.get('ariaLabel');
    this.$el.empty().append(
      tmplDropdownButtonCell({
        name: _.isFunction(this.name) ? this.name.bind(this) : this.name,
        labelClass: this.labelClass,
        disabled: this.disabled,
        buttonClass,
        ariaLabel,
        actions,
        buttonParentClass: this.buttonParentClass
      })
    );
    this.delegateEvents();
    return this;
  },

  onClickDropdownLink(e) {
    e.preventDefault();
    if (this.onClick && _.isFunction(this.onClick)) {
      this.onClick(e, this.model);
    }
  }
});

export default DropdownCell;
